module.exports = __WEBPACK_EXTERNAL_MODULE_978__;


//////////////////
// WEBPACK FOOTER
// external "react-widget"
// module id = 978
// module chunks = 27 28 38 42 43 48 50 51 71 75 81 101 117 118 122 124 125 128 130 144 146 153 162